// Show each table's "Swipe to see more" line (functions.php) only while the
// table is wider than its box and scrolls sideways.
function initTableScrollHints() {
  var hints = document.querySelectorAll('.table-scroll-hint');
  if (!hints.length || !('ResizeObserver' in window)) return;

  hints.forEach(function(hint) {
    var figure = hint.nextElementSibling;
    if (!figure || !figure.classList.contains('wp-block-table')) return;

    new ResizeObserver(function() {
      hint.hidden = figure.scrollWidth <= figure.clientWidth + 1;
    }).observe(figure);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initScrollAnimations();
  initStickyHeader();
  initAccordionScrollMobile();
  initTableScrollHints();
});
